import { ONBOARDING_STATE, QUESTION_MODAL_STATE } from "../../core/constants";
import { translate } from "../../core/i18n";
import { getDomainCfg, store } from "../../core/state";
import { getComponentData } from "../../core/views";
import { CARD_UNKNOWN, HAS_CARDS, NO_CARDS, dissmissOnboarding, setCurrentJourneyFinished, setCurrentOnboardingStep, setHasCodingCards } from "../../features/onboarding";
import { useEffect, useState } from "react";
import { QuestionModal, showQuestionModal } from "./QuestionModal";
import { hideLoginModal, showLoginRegisterModal } from "./LoginRegisterModal";
import { getCloudData, getCloudUser } from "../../features/cloudstorage/cloud";

export const HasCardsModal = () => {
  const [onboarding] = store.useState(ONBOARDING_STATE);
  const [showCardQuestion, setShowCardQuestion] = useState(true);

  const hasCards = () => {
    setHasCodingCards(HAS_CARDS);
    const domainCfg = getDomainCfg();
    const deVersion = domainCfg.lang === 'de';
    const schoolVersion = domainCfg.product.private === true;
    const hideFirstTimeButton = !schoolVersion && !deVersion && getDomainCfg().product.activationUrl !== undefined;        
    setTimeout(() => {
      console.log('HasCardsModal: hasCards', onboarding, hideFirstTimeButton);
      showLoginRegisterModal(hideFirstTimeButton, !hideFirstTimeButton);
      setCurrentOnboardingStep(1)
    }, 300);
  }

  const doesntHaveCards = () => {
    setHasCodingCards(NO_CARDS);
    setCurrentJourneyFinished(onboarding.currentStep);
    hideLoginModal();
    setCurrentOnboardingStep(11);
  }

  useEffect(() => { 
    const modalState = getComponentData(QUESTION_MODAL_STATE);
    const showModal = onboarding.hasCodingCards === CARD_UNKNOWN 
                      && (!modalState.data || modalState.data?.show === false) 
                      && getDomainCfg().viewSettings.features.hasOnboarding
                      && getDomainCfg().product.private !== true
                      //&& getDomainCfg().lang === 'de'
                      && !getCloudUser().loggedIn
    if (showModal) {
      console.log('HasCardsModal: onboarding', onboarding);   
      const opts = {
        okTitle : translate('view-portal-question-ok'),
        okColor : "btn-warning",
        cancelTitle : translate('view-portal-question-cancel'),
        titlesAsDetail: true,
        large: true,
        closingDisabled: true,
        closeWindowLink : false
      }
      const bodyText = `<div class="text-center">${translate('view-portal-question')}</div>`;
      showQuestionModal(translate('view-portal-question-title'), bodyText, hasCards, doesntHaveCards, opts);
      hideLoginModal();
      setShowCardQuestion(true);
      
    }
  }, []);


  return <QuestionModal />;
}